import store from 'store2'

import post from '../../../lib/post'

export default function(o,data,id,collection,done){

  var ombStore = store.namespace('omb')

  post(
    'data',
    {
      token: ombStore('token'),
      type: 'remove',
      collection: collection,
      id: id,
    },
    function(error, result){
      if(error){
        done(error)
      } else {
        o.sounds.beep.play()
        o.feedback.ok('document removed')
        _.remove(data,{_id:id})
        done()
      }
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/documentRemove.js